// extracted by mini-css-extract-plugin
module.exports =  {"button":"_35875ce240--button--_uv0B"};